import { IMatchStartupFormations } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchLineups } from './typeguards';
import { CreateLmpLineupInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchLineupsQuery } from '../types';
import { transformFormationFields } from '../../../utils/formation/formation';
// import { intcmpMap } from '../../../utils/intcmp';

export default (obj: LmpMatchLineupsQuery): IMatchStartupFormations=> {
  if (isValidLmpMatchLineups(obj)) {
    CreateLmpLineupInputSchema().parse(obj.data.lineups, {reportInput: true});
    const { lineups } = obj.data;

    const removeFullname = (player: any) => {
      const { fullname, ...rest } = player;
      return { ...rest, fullName: fullname};
    }

    return {
      matchFormations: {
        matchId: lineups!.matchId,
        status: lineups!.status,
        referees: lineups!.referees?.map(removeFullname),
        away: {
          ...lineups!.away,
          playerList: {
            startingLineup: lineups!.away!.playerList?.startingLineup?.map(removeFullname),
            substitutes: lineups!.away!.playerList?.substitutes?.map(removeFullname),
            manager: removeFullname(lineups!.away!.playerList?.manager)
          },
          logoUrl: lineups!.away!.negativeLogoUrl || lineups!.away!.logoUrl,
        },
        home: {
          ...lineups!.home,
          playerList: {
            startingLineup: lineups!.home!.playerList?.startingLineup?.map(removeFullname),
            substitutes: lineups!.home!.playerList?.substitutes?.map(removeFullname),
            manager: removeFullname(lineups!.home!.playerList?.manager)
          },
          logoUrl: lineups!.home!.negativeLogoUrl || lineups!.home!.logoUrl,
        },
      },
      matchFormationsFields: transformFormationFields(lineups, 'LMP'), // FIELD data
    } as IMatchStartupFormations;

  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchLineupsQuery object',
      data: obj
    });
  }
};
